import axios from "axios";

import { LossAnalysisResult, CategoryMetadata, MetricMetadata } from "./models";
import APP_CONFIG from "../app/configuration/AppConfig";

export async function getLossAnalysisAsync(
  siteId: string,
  start: Date,
  end: Date,
  cancellationToken?: AbortSignal
): Promise<LossAnalysisResult | null> {
  const url = `${APP_CONFIG.serviceUrls.apiHostUrl}/lossAnalyses/sites/${siteId}/analysis?startUtc=${start.toISOString()}&endUtc=${end.toISOString()}`;
  const httpResponse = await axios.get<LossAnalysisResult>(url, {
    signal: cancellationToken,
  });
  if (httpResponse.status === 204) {
    return null;
  }

  return httpResponse.data;
}

export async function getEarliestTimestampAsync(
  siteId: string,
  cancellationToken?: AbortSignal
): Promise<Date | null> {
  const url = `${APP_CONFIG.serviceUrls.apiHostUrl}/lossAnalyses/sites/${siteId}/earliestTimestamp`;
  const httpResponse = await axios.get<number>(url, {
    signal: cancellationToken,
  });
  if (httpResponse.status === 204) {
    return null;
  }

  return new Date(httpResponse.data);
}

export async function getLatestTimestampAsync(
  siteId: string,
  cancellationToken?: AbortSignal
): Promise<Date | null> {
  const url = `${APP_CONFIG.serviceUrls.apiHostUrl}/lossAnalyses/sites/${siteId}/latestTimestamp`;
  const httpResponse = await axios.get<number>(url, {
    signal: cancellationToken,
  });
  if (httpResponse.status === 204) {
    return null;
  }

  return new Date(httpResponse.data);
}

export async function getLossAnalysisCategoriesMetadataAsync(): Promise<CategoryMetadata[]> {
  const url = `${APP_CONFIG.serviceUrls.apiHostUrl}/lossAnalyses/metadata/categories`;
  const httpResponse = await axios.get<CategoryMetadata[]>(url);
  return httpResponse.data;
}

export async function getMetricsMetadataAsync(): Promise<MetricMetadata[]> {
  const url = `${APP_CONFIG.serviceUrls.apiHostUrl}/lossAnalyses/metadata/metrics`;
  const httpResponse = await axios.get<MetricMetadata[]>(url);
  return httpResponse.data;
}
